export { default } from './CategoryGraph';
